module.exports = __webpack_public_path__ + "static/assets/5f46c8dc3b8cc2296eb73f013dfce3db.ttf";